(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/user-low-balance.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/user-low-balance.js');

'use strict';

class UserLowBalance extends svs.tur.payment.dialogs.DialogBase {
  constructor(_ref) {
    let onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      price = _ref.price,
      balance = _ref.balance,
      returnUrl = _ref.returnUrl,
      product = _ref.product,
      _ref$isAutoPayAfterDe = _ref.isAutoPayAfterDeposit,
      isAutoPayAfterDeposit = _ref$isAutoPayAfterDe === void 0 ? false : _ref$isAutoPayAfterDe;
    super({
      onConfirm,
      onCancel
    });
    this.balance = balance;
    this.price = price;
    this.returnUrl = returnUrl;
    this.product = product;
    this.isAutoPayAfterDeposit = isAutoPayAfterDeposit;
    this.show();
  }
  getIcon() {
    return 'deposit';
  }
  getTitle() {
    return this.isAutoPayAfterDeposit ? 'Du behöver sätta in pengar för att köpa din andel' : 'Du behöver sätta in pengar för att kunna betala ditt spel.';
  }
  getMessage() {
    const message = [];
    if (this.isAutoPayAfterDeposit) {
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: 'Observera att spelet inte går att annullera',
        align: svs.components.dialog.message.align.CENTER
      });
    }
    if (this.balance) {
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: "Saldo: ".concat(svs.utils.format.Currency(this.balance), " kr"),
        align: svs.components.dialog.message.align.CENTER
      });
    }
    if (this.price) {
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: "Pris: ".concat(svs.utils.format.Currency(this.price), " kr"),
        align: svs.components.dialog.message.align.CENTER
      });
    }
    return message;
  }
  getActions() {
    return [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Avbryt',
      callback: (e, form, dialog) => {
        dialog.close(() => {
          this.onCancel && this.onCancel();
        });
      }
    }, {
      type: svs.components.dialog.button.SECONDARY,
      title: this.isAutoPayAfterDeposit ? 'Sätt in och betala' : 'Sätt in',
      callback: (e, form, dialog) => {
        this.onConfirm && this.onConfirm();
        dialog.close(() => {
          svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsHome'), {
            returnUrl: this.returnUrl || window.location,
            product: this.product,
            price: this.price
          });
        });
      }
    }];
  }
}
svs.tur.payment.dialogs.UserLowBalance = UserLowBalance;

 })(window);